export default {
    applicationName: 'Postarejte se o své vozidlo jednoduše a bez čekání',
    applicationVersion: 'Verze',

    companyLink: 'https://www.drivalia.cz/',

    yes: 'Ano',
    no: 'Ne',

    mapView: 'Mapa',
    listView: 'Seznam',

    contact: 'Kontakt',
    contactLink: 'https://www.drivalia.cz/kontakt/',

    servicesLabel: 'V aplikaci najdete tyto služby',

    maintenanceHeadline: 'Objednání do servisu',
    maintenanceDescription: 'Potřebujete běžný servis, mimořádný servis nebo STK? Na mapě si vyberte nejbližší servisní místo a rovnou se objednejte.',

    tiresHeadline: 'Pneumatiky',
    tiresDescription: 'Hledáte pneuservis? Na mapě najdete nejbližší místa a v jejich detailu kontaktní údaje pro objednání. Objednání probíhá přímo přes kontaktní údaje daného partnera.',

    damageHeadline: 'Škodní událost',
    damageDescription: 'Stala se vám dopravní nehoda nebo došlo k poškození vozidla? Zavolejte nám na <a href="tel:+420296333666">+420 296 333 666</a> rádi vám pomůžeme s dalším postupem.',

    callingActionHeadline: 'Svolávací akce',
    callingActionDescription: 'Byli jste vyzváni k návštěvě servisu kvůli svolávací akci? Vyberte si na mapě vhodný servis a objednejte se.',

    chargingStationHeadline: 'Nabíjecí stanice',
    chargingStationDescription: 'Na mapě najdete ověřené nabíjecí stanice, které podporují karty Drivalia. Stačí si vybrat tu nejbližší.',

    blockedLocationServices: 'Nejprve zadejte prosím adresu, nebo povolte polohové služby.'
}
